import type { OptionLabelPair } from '../../../../components/RadioGroup';
import type { BooleanFlag } from '../../../../types/boolean-flag';
import { BOOLEAN_FLAGS } from '../../../../types/boolean-flag';
import type { SyncDirection } from '../../MorningConfigurationFormSchema';
import { SYNC_DIRECTIONS } from '../../MorningConfigurationFormSchema';
import { INVOICE_NUMBER_SYNC_STRATEGY, InvoiceNumberSyncStrategy } from '@vy/integrations-types';

export const SYNC_CUSTOMERS_OPTIONS: OptionLabelPair<SyncDirection>[] = [
  { value: SYNC_DIRECTIONS.AUTO_SYNC_DISABLED, label: 'Manually link customers to Morning' },
];

export const AUTOMATICALLY_SYNC_INVOICES_OPTIONS: OptionLabelPair<BooleanFlag>[] = [
  { value: BOOLEAN_FLAGS.DISABLED, label: 'Manually sync invoices to Morning' }
];

export const INVOICE_NUMBER_SYNC_STRATEGY_OPTIONS: OptionLabelPair<InvoiceNumberSyncStrategy>[] = [
  {
    value: INVOICE_NUMBER_SYNC_STRATEGY.KEEP_SEPARATE,
    label: 'Keep Invoice Numbers Separate between Morning & Vayu',
  },
  {
    value: INVOICE_NUMBER_SYNC_STRATEGY.ERP_TO_VAYU,
    label: 'Use Morning invoice numbers and override Vayu numbers',
  },
];
